import { connector } from "utils/common/connector";

const controller = "report";

// ---------------------------------------------
// NEW CUSTOMERS REPORT
// ---------------------------------------------
export const getNewCustomerReportService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "reportNewCustomersByMonthForCompany",
      {
        ...params,
        dateFrom: params?.dateFrom
          ? encodeURIComponent(params.dateFrom.toString())
          : undefined,
        dateTo: params?.dateTo
          ? encodeURIComponent(params.dateTo.toString())
          : undefined,
      },
    );

    reply = response ?? [];
  } catch (error) {
    console.log(error);
    reply = [];
  }

  return reply;
};

// ---------------------------------------------
// CONTRACT RENOVATIONS REPORT
// ---------------------------------------------
export const getContractRenovationsReportService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "reportContractRenovationsByMonthForCompany",
      {
        ...params,
        dateFrom: params?.dateFrom
          ? encodeURIComponent(params.dateFrom.toString())
          : undefined,
        dateTo: params?.dateTo
          ? encodeURIComponent(params.dateTo.toString())
          : undefined,
      },
    );

    reply = response ?? [];
  } catch (error) {
    console.log(error);
    reply = [];
  }

  return reply;
};

// ---------------------------------------------
// CUSTOMERS BY CATEGORY REPORT
// ---------------------------------------------
export const getCustomerByCategoryReportService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "reportCustomersByCategory",
      params,
    );

    reply = response ?? [];
  } catch (error) {
    console.log(error);
    reply = [];
  }

  return reply;
};
